
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.333 20.067a.6.6 0 110 1.2h-.484l.442.415.013.014a2.402 2.402 0 003.96-.897.601.601 0 011.132.4 3.603 3.603 0 01-1.002 1.49h-.001a3.6 3.6 0 01-4.924-.133l-.536-.504v.614a.6.6 0 11-1.2 0v-2c0-.011.003-.023.003-.035a.599.599 0 01.008-.075l.012-.045a.59.59 0 01.022-.07l.02-.04c.011-.02.02-.042.033-.062l.027-.036c.013-.016.024-.033.038-.048l.01-.01.027-.023a.613.613 0 01.062-.05c.01-.008.022-.013.032-.02.023-.013.045-.027.069-.037.01-.005.023-.007.034-.011.026-.01.052-.019.079-.024l.021-.003a.594.594 0 01.084-.01h2.019zm.87-3.578a3.604 3.604 0 013.327.954l.537.504v-.613a.6.6 0 111.2 0v2c0 .007-.003.015-.003.023a.606.606 0 01-.01.086l-.009.039a.583.583 0 01-.024.075l-.01.024a.579.579 0 01-.042.078c-.013.02-.028.036-.043.054-.008.01-.014.021-.023.03l-.005.005a.606.606 0 01-.062.053l-.03.025c-.018.013-.038.023-.059.034-.014.008-.028.017-.043.023l-.036.013a.6.6 0 01-.078.023l-.021.003a.605.605 0 01-.095.01l-.007.001h-2a.6.6 0 110-1.2h.486l-.444-.416-.014-.013a2.402 2.402 0 00-3.175-.194l-.117.096c-.303.27-.532.612-.668.994a.6.6 0 11-1.13-.4 3.6 3.6 0 012.598-2.311z","fill":"#253765"}}),_c('path',{attrs:{"d":"M12.898 5.702a5.63 5.63 0 015.627 5.451 3.573 3.573 0 01-.096 7.145h-.36a6.243 6.243 0 00-.373-1h.733a2.574 2.574 0 00.07-5.145l-.943-.025-.03-.943a4.631 4.631 0 00-4.394-4.477l-.234-.006A4.633 4.633 0 008.5 9.88l-.227.686H6.365a3.364 3.364 0 00-.062 6.73 6.257 6.257 0 00-.367.98 4.366 4.366 0 01.43-8.71H7.55a5.633 5.633 0 015.347-3.864z","fill":"currentColor"}})])
          )
        }
      }
    